// extracted by mini-css-extract-plugin
export default {"percentage":"Percentage_percentage__bGpv7"};